module.exports = __webpack_public_path__ + "media/images/products/retailers-ecommerce-3-sample02-8fbdf1c16b0b71c2859e0b733d13f8f8.jpg";